<template>
  <b-modal @hide="createModalClose" ref="createPartnerBusinessFormModal" :title="$t('得意先一覧')" size="xl" hide-footer no-close-on-backdrop>
    <b-container>
      <loading :active.sync="create.load" :loader="'dots'" :color="'#FFF'" :background-color="'#000'" :can-cancel="false" :is-full-page="true"></loading>
      <div class="d-flex justify-content-end">
        <div class="mt-3 mr-3">
          <q-input
            v-model="search.name"
            dense
            rounded
            outlined
            placeholder="検索"
          >
            <template v-slot:append>
              <q-icon name="search"></q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="table-list inner">
        <div class="content">
          <table class="table table-hover">
            <thead>
              <tr>
                <th width="10%" class="text-center no-border"></th>
                <th width="90%" class="text-left no-border">{{ $t('得意先名称') }}</th>
              </tr>
            </thead>
            <tbody class="tbody">
              <template v-if="!create.load && mixinGetItems.length">
                <template v-for="(item, index) in mixinGetItems">
                  <tr :key="index" style="cursor: pointer;">
                    <td :disabled="item.isOtherRelations">
                      <input
                        v-model="item.isSelected"
                        type="checkbox"
                        class="checkbox"
                        :disabled="item.isOtherRelations"
                      />
                    </td>
                    <td class="text-left" :disabled="item.isOtherRelations">{{ item.name }}</td>
                    <template v-if="item.isOtherRelations">
                      <q-tooltip content-class="bg-green" anchor="center right" self="center right">
                        {{ $t('すでに他帳票に設定されています') }}
                      </q-tooltip>
                    </template>
                  </tr>
                </template>
              </template>
              <template v-else-if="!create.load && !mixinGetItems.length">
                <tr>
                  <td rowspan="2" colspan="99" class="text-center">
                    {{ $t('ノーデータメッセージ') }}
                  </td>
                </tr>
              </template>
              <template v-else-if="create.load">
                <tr>
                  <td colspan="12">
                    <div
                      class="d-flex justify-content-center m-5"
                      v-if="create.load"
                    >
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="inner d-flex justify-content-between">
        <paginate
          :page-count="mixinGetPageCount"
          :force-page="mixinGetForcePage"
          :page-range="3"
          :margin-pages="1"
          :click-handler="mixinClickCallback"
          :prev-text="'«'"
          :next-text="'»'"
          :container-class="'pagination justify-content-end mt-3 mr-0'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          ref="page"
        >
        </paginate>
      </div>
    </b-container>

    <div class="modal-footer flex-column justify-content-end align-items-end">
      <p class="text-danger text-center" v-if="create.error">{{ create.error }}</p>
      <div class="d-flex mt-4 mb-4">
        <div class="mr-4">
          <q-btn rounded @click="createModalClose()" :disabled="create.registration">
            <div class="row text-center no-wrap">
              <svg class="icon mr-4" viewBox="0 0 24 24">
                <use xlink:href="#x-mark-1" />
              </svg>
              <div>{{ $t('Cancel') }}</div>
            </div>
          </q-btn>
        </div>
        <div>
          <q-btn rounded color="success" @click="onRegister()" :disabled="create.registration">
            <svg class="note-31 mr-4" viewBox="0 0 24 24">
                <use xlink:href="#note-31" />
              </svg>
            <div class="row text-center no-wrap">
              <div>{{ $t('Register') }}</div>
            </div>
          </q-btn>
        </div>
      </div>
    </div>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '../../mixin/api'

export default {
  props: {
    partners: Array,
  },
  mixins: [
    Api,
  ],
  data() {
    return {
      search: {
        name: '',
      },
      partnerBusinessForms: [],
      otherRelationPartnerIds: [],
      selectablePartners: [],
      selectedPartnerIds: [],
      create: {
        load: false,
        registration: false,
        error: '',
      },
      id: '',
    }
  },
  methods: {
    async createModalOpen(business_form = {}) {
      await this.getPartnerBusinessForms(business_form)
      this.$refs.createPartnerBusinessFormModal.show()
    },
    createModalClose() {
      this.search.name = ''
      this.$refs.createPartnerBusinessFormModal.hide()
    },
    async getPartnerBusinessForms(business_form = {}) {
      try {
        this.load = true
        const params = { businessFormId: business_form.id }
        this.partnerBusinessForms = await this.mixinGetAPI(`${this.$appConfig.CommonApiUrl}/partner_business_forms`, params)
        const other_relation_params = {
          businessFormId: business_form.id,
          businessFormType: business_form.type,
        }
        this.otherRelationPartnerIds = await this.mixinGetAPI(`${this.$appConfig.CommonApiUrl}/partner_business_forms/other_relations`, other_relation_params)
        this.mixinCurrentPageClear()
        this.id = business_form.id
        this.selectedPartnerIds = this.setSelectedPartnerIds()
        this.selectablePartners = this.setSelectablePartners()
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    async onRegister() {
      const changed_selection_partners = this.selectablePartners.filter(item => item.isSelected !== item.org.isSelected)
      if (!changed_selection_partners.length) return this.$toasted.show(this.$t('変更するデータがありません'))

      const targets = []
      changed_selection_partners.forEach(item => {
        const isDeleted = item.isSelected ? false : true
        const target = {
          partnerId: item.id,
          isDelete: isDeleted,
        }
        targets.push(target)
      })
      const params = {
        businessFormId: this.id,
        targets: targets,
      }

      await this.createRegister(params)
    },
    _createRegister(params) {
      return this.$axios({
        method: 'put',
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
        url: `${this.$appConfig.CommonApiUrl}/partner_business_forms`,
        data: params,
      })
    },
    async createRegister(params) {
      this.create.error = ''
      this.create.registration = true

      try {
        await this._createRegister(params)

        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.create = {
          load: false,
          registration: false,
          error: '',
        }
        this.$refs.createPartnerBusinessFormModal.hide()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.create.registration = false
    },
    setSelectablePartners() {
      return this.partners.map(partner => {
        const isSelected = this.selectedPartnerIds.some(item => item === partner.id)
        const isOtherRelations = this.otherRelationPartnerIds.some(item => item.partnerId === partner.id)
        const new_partner = {
          id: partner.id,
          name: partner.name,
          isSelected: isSelected,
          isOtherRelations: isOtherRelations,
          org: {
            isSelected: isSelected,
            isOtherRelations: isOtherRelations,
          },
        }
        return new_partner
      })
    },
    setSelectedPartnerIds() {
      return this.partnerBusinessForms.map(item => {
        return item.partnerId
      })
    },
  },
  watch: {
    //
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
    list() {
      if (!this.search.name) return this.selectablePartners
      return this.selectablePartners.filter(partner => partner.name && partner.name.indexOf(this.search.name) > -1)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .q-btn__content.col, .row {
    margin: 0 !important;
  }
  .no-border {
    border: none !important;
  }
  .note-31 {
    width: 21px;
    height: 21px;
    fill: white !important;
  }
  .icon {
    width: 21px;
    height: 21px;
  }
  td {
    word-break: break-all;
  }
}
</style>
